module.exports = __webpack_public_path__ + "static/media/CommunityDetails2Screen_elCommunityCoverImage_720907.3871f53e.jpg";